export default "__VITE_ASSET__e1eb15fe__"